export const toTitleCase = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/[^\s-]+/g, (word) =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
};

export const toTitleCaseLive = (str) => {
  if (str === null || str === undefined) return str;
  if (typeof str !== 'string')
    return str;

  let result = '';
  let capitaliseNext = true;

  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    if (ch === ' ') {
      result += ch;
      capitaliseNext = true;
    } else if (capitaliseNext) {
      result += ch.toUpperCase();
      capitaliseNext = false;
    } else {
      result += ch;
    }
  }
  return result;
};

export const normalizeKey = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str.trim().replace(/\s+/g, ' ').toLowerCase();
};

export const deduplicateBy = (items, keyFn) => {
  const seen = new Map();
  items.forEach((item) => {
    const key = normalizeKey(keyFn(item));
    if (key) seen.set(key, item);
  });
  return Array.from(seen.values());
};

export const normalizeAndDeduplicateSuggestions = (suggestions) => {
  if (!Array.isArray(suggestions)) return [];

  const normalized = suggestions.map((s) => ({
    ...s,
    city:     s.city     ? toTitleCase(s.city)     : undefined,
    name:     s.name     ? toTitleCase(s.name)     : undefined,
    address:  s.address  ? toTitleCase(s.address)  : undefined,
    terminal: s.terminal ? toTitleCase(s.terminal) : undefined,
    state:    s.state    ? toTitleCase(s.state)    : undefined,
  }));

  return deduplicateBy(normalized, (s) => s.city || s.name || '');
};